import React, { ReactNode } from "react";
import {
  Box,
  Flex,
  Heading,
  SimpleGrid,
  Stack,
  useColorModeValue,
} from "@chakra-ui/react";
import { HOME_PAGE_CONTAINER_PROPS } from "./HomePage";
import { ReactComponent as intro_illu } from "../../assets/intro_illu.svg";
import { withPrefix } from "gatsby";

export function HomePageIntroLayout({ children }: { children: ReactNode }) {
  const imageColor = useColorModeValue("blue.400", "beige.400");
  return (
    <SimpleGrid
      {...HOME_PAGE_CONTAINER_PROPS}
      as="section"
      py={{
        base: 6,
        md: 88,
        lg: 32,
      }}
      columns={{ md: 2 }}
      spacing={{
        base: 6,
        lg: 14,
      }}
    >
      <Flex direction="column">
        <Heading>Welcome to Apollo Odyssey</Heading>
        <Box maxW="400px" as={intro_illu} fill={imageColor} />
      </Flex>
      <Stack
        spacing="4"
        fontSize="lg"
        sx={{
          a: {
            color: "link",
            _hover: {
              textDecor: "underline",
            },
          },
        }}
      >
        {children}
      </Stack>
    </SimpleGrid>
  );
}
